
import { Reporting } from '../../api/reports/reporting';
import { formatDate, parseDate } from '../../api/dates/date_formatter';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      compareStartDate: '',
      compareStartDateFormatted: '',
      compareEndDate: '',
      compareEndDateFormatted: '',
      startDate: '',
      startDateFormatted: '',
      endDate: '',
      endDateFormatted: '',
      dateType: 'created',

      message: '',
      messageAlert: true
    };
  },
  methods: {
    parseDateInternal(date: string): string {
      return parseDate(date);
    },
    runReport() {
      Reporting.getRevenueComparison(
        this.startDate,
        this.endDate,
        this.compareStartDate,
        this.compareEndDate,
        this.dateType,
      ).then((response) => {
        if (response.data.message) {
          this.messageAlert = true
          this.message = response.data.message
        }
      });
    },
  },
  computed: {
    disableButton(): boolean {
      return !this.compareStartDate || !this.compareEndDate || !this.startDate || !this.endDate
    }
  },
  watch: {
    startDate() {
      this.startDateFormatted = formatDate(this.startDate);
    },
    endDate() {
      this.endDateFormatted = formatDate(this.endDate);
    },
    compareStartDate() {
      this.compareStartDateFormatted = formatDate(this.compareStartDate);
    },
    compareEndDate() {
      this.compareEndDateFormatted = formatDate(this.compareEndDate);
    },
  },
});
